import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCatalogById } from '../../app/helpers/getCatalogById';
import { getObjectById } from '../../app/helpers/getObjectById';
import { getFieldInfo } from '../../app/helpers/getFieldInfo';
import { useTranslation } from 'react-i18next';
import "./tableComparison.css";

const TableHorizontalFullAssistance = ({ data }) => {
  const { t } = useTranslation();

  // 1. Selectores de Redux específicos para Assistance
  const { listFieldsAssistance } = useSelector((state) => state.moduleConfig);
  const { listFullCatalogs } = useSelector((state) => state.catalog);
  const { listFullCatalogCiius } = useSelector((state) => state.catalogCiiu);
  const { listContinents, listFullRegions, listFullCountries } = useSelector((state) => state.locationCountry);

  // 2. Filtros Memoizados
  const comparedData = useMemo(() => data.filter(dta => dta.isCompared || dta.isSelected), [data]);
  const comparableFields = useMemo(() => listFieldsAssistance.filter(f => f.is_comparable), [listFieldsAssistance]);

  // 3. Helper de resolución de texto
  const resolveCellValue = (fieldKey, dataObject) => {
    const fieldFound = getFieldInfo(fieldKey, listFieldsAssistance);
    if (!fieldFound || !fieldFound.is_comparable) return null;

    const val = dataObject[fieldKey];
    const condition = fieldFound.comparable_relation_condition;

    const resolvers = {
      "Fields": () => val,
      "Catalogs": () => getCatalogById(val, listFullCatalogs)?.description,
      "CatalogCiius": () => getObjectById(val, listFullCatalogCiius)?.name,
      "CatalogSections": () => getObjectById(val, listFullCatalogCiius)?.name,
      "CatalogPhases": () => getObjectById(val, listFullCountries)?.name,
      "CatalogCountries": () => getObjectById(val, listFullCountries)?.name,
      "CatalogRegions": () => getObjectById(val, listFullRegions)?.name,
      "CatalogContinents": () => getObjectById(val, listContinents)?.name,
      "Year": () => val ? new Date(val).getFullYear() : '',
    };

    return resolvers[condition] ? resolvers[condition]() : null;
  };

  return (
    <div className='table-horizontal-scroll-full'>
      <table className='table table-comparison'>
        <thead>
          <tr>
            <th className="sticky-corner" style={{ left: 0, zIndex: 11 }}>
              {t('general.table.header.common.fields')}
            </th> 
            {comparedData.map((dta) => (
              <th key={`h-${dta.id}`} scope="col">
                <div className="text-primary">ID: {dta.id}</div>
                <small className="text-muted">{dta.code || 'S/C'}</small>
              </th>
            ))}
          </tr>
        </thead>
        
        <tbody>
          {comparableFields.map((fieldItem) => (
            <tr key={`row-${fieldItem.field}`}>
              <th scope="row" className="sticky-column">
                {t(`${fieldItem.module_text}.synthetic.${fieldItem.field}`)}
              </th>
              {comparedData.map((dta) => (
                <td key={`cell-${fieldItem.field}-${dta.id}`} className="align-middle">
                  {resolveCellValue(fieldItem.field, dta) || (
                    <span className="text-muted small">---</span>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {comparedData.length === 0 && (
        <div className="text-center p-4 text-muted">
          {t("general.no-data-selected")}
        </div>
      )}
    </div>
  );
};

export default TableHorizontalFullAssistance;
